import { DWSCompletedController } from './completed.controller';
import template from './completed.html';

export const dwsCompletedComponent = {
  name: 'dwsCompletedComponent',
  restrict: 'E',
  template,
  controller: DWSCompletedController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<',
  },
};
